import { QuestionItem, ProgressTabListItemType } from ".";

const data: ProgressTabListItemType[] = [

];
export default data;
export const Questiondata: QuestionItem[] = [
  
];
